const baseURL = {
    local: 'https://test-svc.ecal.com',
    devlocal: 'http://127.0.0.1:3050',
    test: 'https://test-svc.ecal.com',
    stage: 'https://stage-svc.ecal.com',
    prod: 'https://svc.ecal.com',
};

export default baseURL;
